'use client'

import { useEffect, useState } from 'react'
import { useSearchParams, usePathname } from 'next/navigation'
import Modal from '@audioeye-marketing/ui/src/components/Modal'
import ModalClose from '@audioeye-marketing/ui/src/components/ModalClose'
import ModalDialog from '@audioeye-marketing/ui/src/components/ModalDialog'
import DialogContent from '@audioeye-marketing/ui/src/components/DialogContent'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import colors from '@audioeye-marketing/ui/src/theme/colors'

const EasterEggs = () => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const easterEggParam = searchParams.get('easterEgg')
  const [sequence, setSequence] = useState([])
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const setMaxMode = () => {
      document.querySelectorAll('img').forEach((img) => {
        if (!img.classList.contains('header-logo')) {
          img.srcset = ''
          img.src = 'https://a-us.storyblok.com/f/1015620/512x512/76e3f05495/maxwell-johnsen-easter-egg.jpeg'
        }
      })

      document.querySelectorAll('.MuiButton-root').forEach((button) => {
        button.innerText = 'Oink 🐽'
      })
    }

    const isMaxMode = sessionStorage.getItem('max') === 'true'

    if (isMaxMode) {
      setMaxMode()
    }

    if (easterEggParam === 'max') {
      sessionStorage.setItem('max', 'true')
      setMaxMode()
    }

    if (easterEggParam === 'off') {
      sessionStorage.removeItem('max')
    }

    return () => {
      const isMaxMode = sessionStorage.getItem('max') === 'true'

      if (isMaxMode) {
        setMaxMode()
      }
    }
  }, [easterEggParam, pathname])

  // Chad Mode
  useEffect(() => {
    const setChadMode = () => {
      const root = document.documentElement
      root.style.setProperty('--joy-palette-primary-50', colors.warning[50])
      root.style.setProperty('--joy-palette-primary-100', colors.warning[100])
      root.style.setProperty('--joy-palette-primary-200', colors.warning[200])
      root.style.setProperty('--joy-palette-primary-300', colors.warning[300])
      root.style.setProperty('--joy-palette-primary-400', colors.warning[400])
      root.style.setProperty('--joy-palette-primary-500', colors.warning[500])
      root.style.setProperty('--joy-palette-primary-600', colors.warning[600])
      root.style.setProperty('--joy-palette-primary-700', colors.warning[700])
      root.style.setProperty('--joy-palette-primary-800', colors.warning[800])
      root.style.setProperty('--joy-palette-primary-900', colors.warning[900])
    }

    const resetChadMode = () => {
      const root = document.documentElement
      root.style.setProperty('--joy-palette-primary-50', colors.primary[50])
      root.style.setProperty('--joy-palette-primary-100', colors.primary[100])
      root.style.setProperty('--joy-palette-primary-200', colors.primary[200])
      root.style.setProperty('--joy-palette-primary-300', colors.primary[300])
      root.style.setProperty('--joy-palette-primary-400', colors.primary[400])
      root.style.setProperty('--joy-palette-primary-500', colors.primary[500])
      root.style.setProperty('--joy-palette-primary-600', colors.primary[600])
      root.style.setProperty('--joy-palette-primary-700', colors.primary[700])
      root.style.setProperty('--joy-palette-primary-800', colors.primary[800])
      root.style.setProperty('--joy-palette-primary-900', colors.primary[900])
    }

    const isChadMode = sessionStorage.getItem('chad') === 'true'

    if (isChadMode) {
      setChadMode()
    }

    if (easterEggParam === 'chad') {
      sessionStorage.setItem('chad', 'true')
      setChadMode()
    }

    if (easterEggParam === 'off') {
      sessionStorage.removeItem('chad')
      resetChadMode()
    }

    return () => {
      const isChadMode = sessionStorage.getItem('chad') === 'true'

      if (isChadMode) {
        setChadMode()
      }
    }
  }, [easterEggParam])

  // eyEoiduA Flip Site
  useEffect(() => {
    const isFlipped = sessionStorage.getItem('siteFlipped') === 'true'

    if (isFlipped) {
      document.body.style.transform = 'scaleX(-1)'
    }

    if (easterEggParam === 'eyeoidua') {
      sessionStorage.setItem('siteFlipped', 'true')
      document.body.style.transform = 'scaleX(-1)'
    }

    if (easterEggParam === 'off') {
      sessionStorage.removeItem('siteFlipped')
      document.body.style.transform = ''
    }

    return () => {
      const stillFlipped = sessionStorage.getItem('siteFlipped') === 'true'
      document.body.style.transform = stillFlipped ? 'scaleX(-1)' : ''
    }
  }, [easterEggParam])

  // Konami Code
  useEffect(() => {
    const konamiCode = [
      'ArrowUp',
      'ArrowUp',
      'ArrowDown',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'ArrowLeft',
      'ArrowRight',
      'KeyB',
      'KeyA',
    ]

    const handleKeyPress = (event) => {
      setSequence((prevSequence) => {
        const newSequence = [...prevSequence, event.code]
        if (newSequence.length > konamiCode.length) {
          newSequence.shift()
        }
        return newSequence
      })
    }

    window.addEventListener('keydown', handleKeyPress)

    if (sequence.join(',') === konamiCode.join(',')) {
      setOpen(true)
      setSequence([])
    }

    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [sequence])

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog
        size="lg"
        layout="center"
        sx={{
          width: {
            xs: '90%',
            lg: '50%',
          },
          backgroundColor: 'white',
        }}
      >
        <ModalClose variant="soft" aria-label="close dialog" />
        <DialogContent sx={{ mt: 4 }}>
          <Typography level="h3">🎮 Konami Code Activated! 🎮</Typography>
          <Typography>{`Well done, gamer! You've uncovered a hidden Easter egg. Secrets like this are only found by true adventurers!`}</Typography>
        </DialogContent>
      </ModalDialog>
    </Modal>
  )
}

export default EasterEggs
